import React, { useState, useRef, useEffect } from "react";
import atoms from "../../atoms";
import molecules from "../../molecules";
import { useDebounce } from "../../hook";

const { Select, BarcodeSearch, Button } = atoms;
const { InternalProductDetail } = molecules;

const Index = ({
    handleBarcodeSearch,
    updateItemCondition,
    barcodeData,
    handleChange,
    updateData,
    inventoryItemCondition,
    inputRef,
}: any) => {
    const bottomRef = useRef<HTMLDivElement>(null);
    const searchTabContainer = useRef<HTMLDivElement>(null);

    const handleDropDown = () => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <div className="row mt-3" ref={bottomRef}>
                <div className="col-md-6">
                    <div className="" ref={searchTabContainer}>
                        <div
                            className="position-relative"
                        >
                            <BarcodeSearch
                                searchCallBack={(val:string) => handleBarcodeSearch(val)}
                                placeholder="Enter Barcode Number"
                                className="fs-16"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 d-none d-md-flex"></div>
            </div>
            {barcodeData ? (
                <>
                    <div className="my-3">
                        <InternalProductDetail barcodeData={barcodeData} />
                    </div>
                    <div>
                        <div className="mt-md-4 mt-2">
                            <div className="col-md-4" onClick={handleDropDown}>
                                <label className="inputs-label mb-2 fs-16 fw-600">
                                    Internal Transfer to
                                </label>
                                <Select
                                    options={inventoryItemCondition}
                                    name={"item_condition"}
                                    value={updateData?.store ? updateData?.store : null}
                                    className={"w-100"}
                                    placeholder={"Select Store"}
                                    onChange={(e: any) => handleChange("store", e)}
                                    menuPlacement={"top"}
                                />
                            </div>
                            <div className="col-md-8"></div>
                        </div>
                    </div>
                    <div className="mx-1 mt-20">
                        <Button
                            name={"Submit"}
                            className={"w-100"}
                            onClick={() => {
                                updateItemCondition(barcodeData?.id);
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="mt-3 d-flex justify-content-center mt-3 dark-gray">
                    <span>There are no records to display</span>
                </div>
            )}
        </>
    );
};

export default Index;
